import React, { useState, useEffect } from 'react'

import {
    Button, Dialog, Grid, Icon, Typography, Select, Switch, Radio,
    FormGroup, FormControl, FormHelperText, RadioGroup, FormControlLabel
} from '@material-ui/core'

import Scrollbars from "rc-scrollbars";
import CloseIcon from '@material-ui/icons/Close';
import useStyles from "./styles";
import { Label, DraggableComponent } from '../../../../../components/UiElements/UiElements';
import { SelectField, InputBaseField, TextareaField } from '../../../../../components/InputField/InputField';
import DialogLoader from './../../../../../components/Loader/DialogLoader';
import { GetUserInfo } from '../../../../../Services/GetUserInfo';
import { PostDataAPI } from '../../../../../Services/APIService';
import { withSnackbar } from "./../../../../../components/Message/Alert";
import SearchGrid from '../../../../../components/table/SearchGrid';
import { validateEmail, validatePhoneNumber, handleNumberKeyPress } from '../../../../../../src/components/Common/Extensions';

function AddDistributer({ dialogOpenClose, handleClose, handleSuccessClose, selectedListId, ...props }) {
    const classes = useStyles();
    const { showMessage } = props;
    const [isLoading, setIsLoading] = useState(false);

    const [state, setState] = useState({});

    const [errorMessages, setErrorMessages] = useState({});
    const [lstAgencies, setLstAgencies] = useState([]);
    const [lstFilteredAgencies, setLstFilteredAgencies] = useState([]);
    const handleChange = e => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }));
    }
    const handleAgencyTypeChange = e => {
        const { name, value } = e.target;
        if (value == '') {
            setLstFilteredAgencies(lstAgencies);
        }
        else {
            setLstFilteredAgencies(lstAgencies.filter(item => item.agencyType == value));
        }
        handleDataGridUpdate();
        setState(prevState => ({
            ...prevState,
            [name]: value
        }));
    }
    const Validate = (errorList) => {
        if (!state.listName) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorListName: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorListName: false
            }));
        }

    }

    const handleOptionChange = e => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const addNew = () => {

        //resetErrors();
        let errorList = [];
        Validate(errorList);
        if (errorList.length < 1) {
            setIsLoading(true);
            state.lstAgencies = selectedRowIds.map(id => { return { agencyId: id } });
            state.agenciesCount = selectedRowIds.length;
            state.category = 'LOS'
            var method = "fdndistributionlist/add";
            if (selectedListId > 0)
                method = "fdndistributionlist/update";
            state.listName = state.listName.trim()
            state.shortDescription = state.shortDescription?.trim()
            PostDataAPI(method, state, true).then((result) => {
                if (result.success) {
                    if (result.data) {
                        setIsLoading(false);
                        var message = "Distribution list added successfully";
                        if (selectedListId > 0)
                            message = "Distribution list updated successfully";
                        handleSuccessClose(message);

                    }
                    else {
                        showMessage("Error", "Error adding distribution list, please contact administrator", "error", 3000);
                    }
                }
                else {
                    showMessage("Error", result.message, "error", 3000);

                }
                setIsLoading(false);

            })
        }

    }

    const [isDataGridUpdate, setIsDataGridUpdate] = useState(false);
    const handleDataGridUpdate = () => {
        setIsDataGridUpdate(!isDataGridUpdate);
    }
    const loadAgencies = () => {
        setIsLoading(true);
        var params = { agencyCategory: 'LOS' }
        PostDataAPI("fdndistributionlist/getAgencies", params).then((result) => {
            if (result.success && result.data) {
                setLstAgencies(result.data);
                setLstFilteredAgencies(result.data);
                handleDataGridUpdate();
            }
            else {
                showMessage("Error", result.message, "error", 3000);
            }
            setIsLoading(false);
        });
    }
    const [selectedRowIds, setSelectedRowsIds] = useState([]);
    const loadDistributionList = () => {
        setIsLoading(true);
        PostDataAPI("fdndistributionlist/get", selectedListId).then((result) => {
            if (result.success && result.data) {
                setState(result.data);
                setLstAgencies(result.data.lstAgencies);
                setLstFilteredAgencies(result.data.lstAgencies);
                setSelectedRowsIds(result.data.lstAgencies.filter(t => t.selectedAgencyId > 0).map(ag => ag.selectedAgencyId));
                handleDataGridUpdate();
            }
            else {
                showMessage("Error", result.message, "error", 3000);
            }
            setIsLoading(false);
        });
    }
    const [agencyType, setAgencyType] = useState([]);

    const getSelection = (keys) => {
        setSelectedRowsIds(keys);
        setState(prevState => ({
            ...prevState,
            agenciesCount: keys.length
        }));
    }
    const loadAgencyType = () => {
        var params = {
            code: "get_agency_type_list",
            parameters: ['']
        };

        PostDataAPI("ddl/loadItems", params).then((result) => {
            if (result.success && result.data != null) {
                setAgencyType(prevState => [...prevState, { value: '', label: 'All' }]);
                result.data.map((item, i) => {
                    setAgencyType(prevState => [...prevState, { value: item.t2, label: item.t3 }]);
                })
            }
        })
    }
    useEffect(() => {
        loadAgencyType();
        if (selectedListId && selectedListId > 0)
            loadDistributionList();
        else
            loadAgencies();
    }, []);


    return (
        <>

            <Dialog
                classes={{ paper: classes.dialogPaper }}
                disableEscapeKeyDown
                open={dialogOpenClose}
                maxWidth="md"
                PaperComponent={DraggableComponent}
                {...props} >
                <div className={classes.activeDialogContent}>
                    <div className={classes.box}>
                        <div className={classes.header} id="draggable-dialog-title">
                            <Typography className={classes.title}>{selectedListId && selectedListId > 0 ? "Edit Distribution List" : "New Distribution List"}</Typography>
                            <Icon className={classes.closeIcon} onClick={handleClose} color="primary"><CloseIcon /></Icon>
                        </div>
                        {isLoading ? <DialogLoader></DialogLoader> : ''}

                        <div className={classes.content}>
                            <Grid container spacing={2}>

                                <Grid lg={6} md={6} xs={12} sm={12} className={classes.paddingLeftRight} >
                                    <Grid row >
                                        <Label item title="List Name" size={12} mandatory={true} />
                                        <Grid lg={12} md={12} sm={12}>
                                            <InputBaseField
                                                name="listName"
                                                type="text"
                                                placeholder="List Name"
                                                MaxLength="50"
                                                value={state.listName}
                                                onChange={handleChange}
                                            />
                                            {errorMessages.errorListName && !state.listName ? (<FormHelperText style={{ color: "red" }} >
                                                Please enter distribution list name
                                            </FormHelperText>) : ('')}
                                        </Grid>
                                    </Grid>

                                </Grid>

                                <Grid lg={6} md={6} xs={12} sm={12} className={classes.paddingLeftRight} >
                                    <Grid row >
                                        <Label item title="Description" size={12} />
                                        <Grid lg={12} md={12} sm={12}>
                                            <InputBaseField
                                                name="shortDescription"
                                                type="text"
                                                placeholder="Description"
                                                MaxLength="50"
                                                value={state.shortDescription}
                                                onChange={handleChange}
                                            />
                                        </Grid>
                                    </Grid>

                                </Grid>
                                <Grid lg={6} md={6} xs={12} sm={12} className={classes.paddingLeftRight} >
                                    <Grid row >
                                        <Label item title="Agency Type" size={12} />
                                        <Grid lg={12} md={12} sm={12}>
                                            <SelectField
                                                options={agencyType}
                                                onChange={handleAgencyTypeChange}
                                                placeholder="Agency Type"
                                                name="agencyType"
                                                value={state.agencyType} />
                                        </Grid>
                                    </Grid>

                                </Grid>
                            </Grid>


                        </div>

                        <div className={classes.contentSecond}>

                            <SearchGrid
                                columns="LosAgencyListForDistributer"
                                list={lstFilteredAgencies}
                                noRecordMsg="No record exists"
                                Icon={true}
                                isSelection={true}
                                getSelectedRows={(keys) => getSelection(keys)}
                                isUpdate={isDataGridUpdate}
                                alreadySelectedRows={selectedRowIds}

                            />

                        </div>

                        <div className={classes.footer}>
                            <div className={classes.footerRight}>
                                <Button className={classes.backBtn} onClick={handleClose}>Cancel</Button>
                                <Button className={classes.changeBtn} onClick={addNew}>Save</Button>
                            </div>
                        </div>

                    </div>
                </div>
            </Dialog >
        </>
    )
}

export default withSnackbar(AddDistributer); 